export default __webpack_public_path__ + "static/media/geisha.b2e8ac05.png";